import type { CropVarietyConfigurationsByKey } from "../types.js";

export const boysenberryVarietyConfigurations = {
    "boysenberry.boysen": { crop: "boysenberry", aliases: ["Boysenberry"], isExample: false, customName: false },
    "boysenberry.thornless-boysen": {
        crop: "boysenberry",
        aliases: ["Thornless Boysenberry"],
        isExample: false,
        customName: false,
    },
    "boysenberry.custom": { crop: "boysenberry", aliases: [], isExample: false, customName: true },
} as const satisfies CropVarietyConfigurationsByKey;
